import React from 'react';
import T from 'prop-types';

import NewFeatureRequestButton from '../../NewFeatureRequestButton';
import Tooltip from '../../Tooltip';

const CsvExportTooltip = ({
  children,
  enableTooltip,
  allowCsvExport,
  tooltipText,
  colorVariant,
  featureNameText,
  id = 'csv-export-button',
  renderCustomTooltipContent,
  onVisibleChange = () => {},
}) => {
  const deraultTooltipContent = () => {
    if (!allowCsvExport) {
      return (
        <div className="d-flex flex-column justify-content-center">
          <p>
            Data export functionality is not currently available on your plan. Reach out to your
            account manager to request access to this feature.
          </p>
          <NewFeatureRequestButton
            featureName={featureNameText}
            buttonText="Request access &nbsp;&#10095;"
            buttonClassName="hms-btn hms-btn--primary tooltip-button"
            modalClassName="modal-in-tooltip"
          />
        </div>
      );
    }

    return tooltipText;
  };

  const tooltipContent = renderCustomTooltipContent
    ? renderCustomTooltipContent()
    : deraultTooltipContent();

  return (
    <Tooltip
      id={id}
      content={enableTooltip ? tooltipContent : null}
      placement="bottomRight"
      colorVariant={colorVariant}
      wrapChildrenInHtmlNode
      onVisibleChange={onVisibleChange}
    >
      {children}
    </Tooltip>
  );
};

CsvExportTooltip.propTypes = {
  children: T.node.isRequired,
  enableTooltip: T.bool,
  allowCsvExport: T.bool,
  tooltipText: T.string,
  featureNameText: T.string,
  id: T.string,
  colorVariant: T.string,
  renderCustomTooltipContent: T.func,
  onVisibleChange: T.func,
};

export default CsvExportTooltip;
